var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLinkedinInBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_678_3014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4812 31.6988C7.8187 31.7426 0.712446 24.5426 0.912446 15.7551C1.09995 7.38007 8.0437 0.442572 16.6874 0.542572C25.2249 0.642572 32.2749 7.75507 32.0499 16.5426C31.8374 24.8801 24.9624 31.7363 16.4812 31.6988ZM2.8062 16.1363C2.87495 23.9676 9.2062 29.9863 16.6937 29.8738C23.9562 29.7613 30.1437 23.8488 30.1499 16.1238C30.1499 8.29882 23.7687 2.24882 16.2624 2.37382C8.98745 2.49257 2.8562 8.41757 2.8062 16.1363Z",
    fill: "#F25C05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7062 23.4739C20.7062 23.3364 20.7062 23.2176 20.7062 23.0926C20.7062 21.4239 20.7125 19.7614 20.7 18.0926C20.7 17.8051 20.675 17.5051 20.6062 17.2301C20.3812 16.3051 19.6312 15.8426 18.55 15.9301C17.75 15.9926 17.0312 16.7051 16.975 17.5301C16.9375 18.0301 16.95 18.5301 16.9437 19.0301C16.9375 20.3864 16.9437 21.7364 16.9437 23.0926C16.9437 23.2176 16.9437 23.3364 16.9437 23.4801C15.9312 23.4801 14.9437 23.4801 13.9375 23.4801C13.9375 20.2301 13.9375 16.9739 13.9375 13.7051C14.9187 13.7051 15.9 13.7051 16.9187 13.7051C16.9187 14.0864 16.9187 14.4739 16.9187 14.9426C17.025 14.8176 17.0875 14.7551 17.1312 14.6801C18.4812 12.6551 22.1437 12.8739 23.2312 15.2614C23.5312 15.9239 23.7125 16.6176 23.7187 17.3426C23.7375 19.3489 23.7312 21.3614 23.7312 23.3739C23.7312 23.4051 23.725 23.4364 23.7125 23.4864C22.725 23.4739 21.7312 23.4739 20.7062 23.4739Z",
    fill: "#F25C05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0125 23.4867C11.0062 23.4867 10.0312 23.4867 9.03125 23.4867C9.03125 20.243 9.03125 17.0117 9.03125 13.7617C10.025 13.7617 11.0062 13.7617 12.0125 13.7617C12.0125 16.993 12.0125 20.2242 12.0125 23.4867Z",
    fill: "#F25C05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4312 11.812C9.5375 11.8057 8.9125 11.1557 8.91875 10.2557C8.925 9.35571 9.575 8.73696 10.5062 8.74321C11.3937 8.74946 12.0375 9.40571 12.025 10.2995C12.025 11.187 11.3562 11.8182 10.4312 11.812Z",
    fill: "#F25C05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_678_3014"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.293701)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedinInBrands);
export default __webpack_public_path__ + "static/media/footer-linkedin-in-brands.dcf01925fa84058efd16e08a397f22ad.svg";
export { ForwardRef as ReactComponent };